const trimOrEmpty = (v) => (typeof v === 'string' ? v.trim() : '');

/** Square TradeStation mark (blue bg, white "T" glyph) used for compact icon badges. */
export function tradestationBrokerIconUrl() {
  const base = trimOrEmpty(process.env.PUBLIC_URL);
  return `${base}/images/brokers/TradeStation.png`;
}

/** Connect Trade square mark (navy rounded square, ">_" cutout) used for compact icon badges. */
export function connectTradeLogoUrl() {
  const base = trimOrEmpty(process.env.PUBLIC_URL);
  return `${base}/images/broker-connecttrade-logo.svg`;
}
